import helper from '../../helper';
import ResponseDataExtractor from '../utils/ResponseDataExtractor';
import router from '../../router';
import RetryWorker from '../utils/RetryWorker';
import ErrorHandle from '../utils/ErrorHandle';

export default {
    getAddressEntitlementV3({ commit }, addressId) {
        /*
            Stry: [US443] As a user, I want to see the entitlements summary
            Date: 2021-01-11
            Auth: Franco Mapua
            Desc: Updating the address entitlement api to version 3
        */
        let url = process.env.MIX_API_URL + 'get-address-entitlement-v3'
        let data = {
            params: {
                id : addressId
            },
        }
        return axios.get(url, data)
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if(data && data.entitlements){
                    if(window.location.href.indexOf('entitlementdebug') > -1 ){
                        data.entitlements.forEach(entitlement => entitlement.entitlementsRemaining = 45) // FIXME
                    }

                    const params = helper.getSearchParameters();
                    if (params && params.entitlementperiodstarttozero) {
                        data.entitlements.forEach(entitlement => {
                            if (entitlement.entitlementStartDate === params.entitlementperiodstarttozero) {
                                entitlement.entitlementsRemaining = 0;
                            }
                        });
                    }

                    data.list = data.entitlements
                    data.entitlements = null;
                }
                commit('SET_ADDRESS_ENTITLEMENT', data);
                return data
            })
            .catch(e => {
                const { statusCode } = new ErrorHandle(e).format;
                if(statusCode == 408) {
                    axios.post(process.env.MIX_API_URL +  'send-failed-api-response-email', {
                        'request_uri': 'get-address-entitlement-v3'
                    });
                }
                console.log('Error when address entitlement from api')
            });
        },
    setPageLoading({
        commit
    }, data) {
        commit('SET_PAGE', data);
        router.push('/');
        commit('SET_PAGE', {
            loading: false
        });
    },
    getUser({
        commit
    }, email) {
        commit('SET_PAGE', {
            loading: true
        });
        commit('SET_PERSONAL_INFO', {
            error: '',
            loading: true
        });
        axios.post(process.env.MIX_API_URL + 'get-user', {
                email
            })
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if (data.hasOwnProperty('outcome') && data.outcome.error == 'true') {
                    commit('SET_PERSONAL_INFO', {
                        error: data.outcome.message,
                        loading: false
                    });
                    commit('SET_PAGE', {
                        loading: false
                    });
                } else {
                    const d = {
                        firstName: data.firstname,
                        lastName: data.lastname,
                        phone: data.phone,
                        email: data.email,
                        type: data.type
                    };
                    commit('SET_PERSONAL_INFO', {
                        error: '',
                        loading: false,
                        ...d
                    });
                    commit('SET_PAGE', {
                        loading: false
                    });
                    this.dispatch('setBasicDetails', data);
                }
                setTimeout(() => { router.push('/booking') }, 2000 );
            })
            .catch((e) => {
                const { statusCode, error } = new ErrorHandle(e).format;
                if(statusCode == 408) {
                    axios.post(process.env.MIX_API_URL +  'send-failed-api-response-email', {
                        'request_uri': 'get-user'
                    });
                }

                commit('SET_AUTH', {
                    token_hash: e.response.data.token_hash,
                    error: JSON.parse(e.response.request.responseText).message
                });
                commit('SET_PAGE', {
                    loading: false
                });

                localStorage.removeItem("AuthToken");
            });
    },
    footerSettings({
        commit
    }) {
        axios.get(process.env.MIX_API_URL + 'cms/ui-setting/footer-content')
        .then(response => new ResponseDataExtractor(response).data)
        .then(data => {
            if(data.list && data.list.length > 0){
                var logoPathAttribute;
                try {
                    logoPathAttribute = JSON.parse(data.list[0].logo_path_attribute) || {alt: '', title: ''};
                } catch (error) {
                    logoPathAttribute = {alt: '', title: ''};
                }
                commit('SET_FOOTER_SETTINGS', {
                    contactNumber: data.list[0].contact_number,
                    copyrightText: data.list[0].copyright_text,
                    councilName:data.list[0].council_name,
                    email: data.list[0].email,
                    isSecondFooter: data.list[0].is_second_section,
                    logoPath: data.list[0].logo_path,
                    logoPathAttribute: logoPathAttribute,
                    operatingHours: data.list[0].operating_hours,
                    footer_links: data.list[0].footer_link
                });
            }
        })
        .catch(e => console.error('Error when get footer setting data from api', helper.errorCatch(e)));
    },
    // paymentAPI({
    //     commit
    // }) {
    //     axios.get(process.env.MIX_API_URL + 'cms/api-setting/payment-api')
    //     .then(response => new ResponseDataExtractor(response).data)
    //     .then(data => {
    //         if(data.list){
    //             commit('SET_PAYMENT_API', {
    //                 merchantCode: data.list[0].merchant_code,
    //                 customerNumber: data.list[0].customer_number
    //             });
    //         }
    //     })
    //     .catch(e => {
    //     });
    // },
    landingPageContent({
        commit
    }) {
        axios.get(process.env.MIX_API_URL + 'cms/ui-setting/landing-page-content')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if(data.list){
                    commit('SET_LANDING_PAGE_CONTENT', {
                        login_heading: data.list[0].login_heading,
                        login_button_link: data.list[0].login_button_link,
                        login_content: data.list[0].login_content,
                        registration_heading: data.list[0].registration_heading,
                        registration_button_link: data.list[0].registration_button_link,
                        registration_content: data.list[0].registration_content,
                        login_button_name: data.list[0].login_button_name,
                        registration_button_name: data.list[0].registration_button_name
                    });
                }
            })
            .catch(() => console.log('Error when get landing page content from api'));
        },
    getWorkOrder({ commit }, addressId) {
        var limit = 20
        return new Promise((mainResolve, mainReject) => {
            new RetryWorker(10, 500, 
                function(){
                    window.axios.defaults.headers.common['Authorization'] = localStorage.AuthToken;
                    return new Promise((resolve, reject) => {
                        axios.get(process.env.MIX_API_URL + 'work-order-search',{
                            params: {
                                id : addressId,
                                limit
                            }
                        })
                            .then(response => new ResponseDataExtractor(response).data)
                            .then(data => {
                                
                                // Double Check if the List returned is actually at the limit
                                if(data.workOrders && data.workOrders.length > limit){
                                    data.workOrders = data.workOrders.splice(0,limit)
                                }
                                commit('SET_WORK_ORDER', data);
                                resolve(data);
                            })
                            .catch(e => {
                                const { statusCode } = new ErrorHandle(e).format;
                                if(statusCode == 408) {
                                    axios.post(process.env.MIX_API_URL +  'send-failed-api-response-email', {
                                        'request_uri': 'work-order-search'
                                    });
                                }
                                console.log('Error when get work order');
                                reject(e);
                            })
                    });
                },
                function(result){
                    mainResolve(result)
                },
                function(error){
                    mainReject(error)
                },
            ).doWork();
        });
    },
    checkRegConfirmation({ commit },  hash ) {
        axios.post(process.env.MIX_API_URL + 'checkRegConfirmation', { tk : hash } )
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                 commit('SET_REGISTER_CONFIRMATION', {
                    codeStatus: data.status,
                    message: data.message
                }); 
            })
            .catch(e => {
                commit('SET_REGISTER_CONFIRMATION', {
                    codeStatus: e.response.status,
                    message: e.response.data.message
                }); 
            });
    },
    resendConfirmationEmail({ commit },  hash ) {
        commit('SET_RESEND_CONFIRMATION_EMAIL', {
            codeStatus: null,
            message: null
        }); 
        axios.post(process.env.MIX_API_URL + 'resendConfirmationEmail', { tk : hash } )
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                 commit('SET_RESEND_CONFIRMATION_EMAIL', {
                    codeStatus: data.status,
                    message: data.message
                }); 
            })
            .catch(e => {
                commit('SET_RESEND_CONFIRMATION_EMAIL', {
                    codeStatus: e.response.status,
                    message: e.response.data.message
                }); 
            });
    },
    validateEmail({ commit }, email) {

        // Retrieve Key
        var AuthKeyStore = require('../utils/AuthKeyStore');
        var key = new AuthKeyStore().retrievePassword();
        
        let url = process.env.MIX_API_URL + 'utility/validate-user-status/' + email;
        var body = { email : email };
        var options = { headers : { SecretToken : key }};

        axios.post(url, body, options)
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {

                var message = data.message
                var errorMsg = null;
                if(!message || typeof message != 'string'){
                    errorMsg = 'Could not contact the server.'
                } else{
                    message = message.toLowerCase().trim()

                    if(message.includes("invalid email")){
                        errorMsg = 'We couldn\'t find a verified account with that information.'
                    }
                    else if(message.includes("pending")){
                        errorMsg = 'Your account is still pending for activation. Please check your email inbox.'
                    }
                    else if(message.includes("active")){
                        errorMsg = null
                    }
                    else if(message.includes("suspended")){
                        errorMsg = "Account Suspended";
                    }
                    else{
                        errorMsg = 'Could not contact the server.'
                    }
                }

                if(errorMsg){
                    throw new Error(errorMsg)
                }
                else{
                    commit('SET_VALIDATE_EMAIL_RESULT', data);
                }
            })
            .catch(err => {
                commit('SET_VALIDATE_EMAIL_RESULT', null);
                commit('SET_VALIDATE_EMAIL_ERROR', err.message);
            });
    },
    setWebsiteMetadata({commit}, data){
        commit('SET_WEBSITE_METADATA', data);
    },
    getServiceWording({commit}) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/service-wordings')
        .then(response => new ResponseDataExtractor(response).data)
        .then(data => commit('SET_SERVICE_WORDING', data))
        .catch(e => console.error('Error when get service wording from api', helper.errorCatch(e)));
    },
    getSiteWordingsSettings({ commit }) {
        axios.get(process.env.MIX_API_URL + 'cms/ui-setting/site-wordings')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if(data && Array.isArray(data.list) && data.list.length > 0){
                    commit('SET_SITE_WORDINGS', data.list[0]);
                }
            })
            .catch(e => console.error('Error when get site wording data from api', helper.errorCatch(e)));
    },
    getStreetAbbreviations({commit}) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/street-abbreviation?limit=20')
        .then(response => new ResponseDataExtractor(response).data)
        .then(data => {
            if(data && Array.isArray(data.list) && data.list.length > 0){
                commit('SET_STREET_ABBREVIATIONS', data);
            }
        })
        .catch(e => { });
    },
    getBinScheduleSetting({ commit }, type) {
        const url = process.env.MIX_API_URL + 'cms/bin-schedule-setting/';
        let promises = [];
        if (type && Array.isArray(type)) {
            promises = [];
            type.forEach(t => {
                promises.push(axios.get(url + t))
            });
        } else {
            promises = axios.get(url + type)
        }
        return Promise.all(promises)
            .then(responses => responses.map(response => new ResponseDataExtractor(response).data))
            .catch(e => console.error('Error when get bin schedule setting from api', helper.errorCatch(e)));
    },
    clearAddressEntitlement({ commit }) {
        commit('SET_ADDRESS_ENTITLEMENT', { list: [], message: null })
    }
}